export const websiteName = "DarkaForexWealth";
export const light = "white";
export const dark = "#020305";
